import { FeedKindPage } from '../components/FeedKindPage';

export function MarketTrendsPage() {
  return (
    <FeedKindPage
      kind="market"
      title="Market Trends"
      description="Aggregated market trend data from your configured market sources."
    />
  );
}
